import React from "react";
import './styles/home.css';


import pffScreenShot from '../img/privateff.png';
import Wrench from '../img/wrench-50.png';
import Sparks from '../img/sparks.png';
import dArrow from '../img/down-arrow-50.png'

const Home = () => {
    return(
        <div className="testPage" style={{width: '100%'}}>
            <header className="w3-container w3-center" style={{padding: '60px 16px', backgroundColor: '#ff0f64', color: 'white'}}>
                <h1 className="w3-margin w3-jumbo" style={{fontWeight: '600'}}>TEST PAGE</h1>
                <img src={Wrench} alt="" />
                <p className="w3-xlarge">Pagina di raccolta e test del software di TLC Telecomunicazioni.</p>
                <img src={dArrow} alt="" />
            </header>

            <div className="w3-row-padding w3-padding-64">
                <div className="rowContent" id="ff">
                    <div className="w3-twothird text-section">
                        <h1><a href="https://private.fiberfinder.it" target="_blank" rel="noreferrer">private.fiberfinder.it</a></h1>
                        <h5 className="w3-padding-32">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</h5>

                        <p className="w3-text-grey">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Excepteur sint
                            occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco
                            laboris nisi ut aliquip ex ea commodo consequat.
                        </p>
                    </div>

                    <div className="w3-third w3-center">
                        <img className="sectionImg" src={pffScreenShot} alt=""/>
                    </div>
                </div>
            </div>

            <div className="w3-row-padding w3-light-grey w3-padding-64">
                <div className="rowContent odd" id="iframe">
                    <div className="w3-third">
                        <span style={{fontSize: '34px', marginRight: 'auto', fontWeight: 'bold', color: '#ff0f64'}}>Provalo qui!</span>
                        <iframe className="iframe" sandbox="allow-scripts allow-same-origin" title="fiberfinderiframe" src="/"></iframe>
                    </div>

                    <div className="w3-twothird text-section">
                        <span style={{color: '#ff0f64', fontSize: '23px', fontWeight: 'bold'}}><img src={Sparks} alt="" style={{width: '40px', borderRadius: '8px'}}/> Novità!</span>
                        <h1>Iframe fiberfinder.it</h1>
                        <h5 className="w3-padding-32">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</h5>

                        <p className="w3-text-grey">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Excepteur sint
                            occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco
                            laboris nisi ut aliquip ex ea commodo consequat.
                        </p>
                    </div>
                </div>
            </div>

            <div className="w3-container w3-center w3-padding-32 w3-opacity" style={{backgroundColor: 'rgb(236, 240, 241)', color: '#ff0f64'}}>
                <h1 className="w3-margin w3-xxlarge" style={{ fontWeight: 'bold'}}>#connectyou</h1>
            </div>

            <footer className="w3-container w3-padding-24 w3-center w3-opacity">  
            <p>Powered by <a href="https://www.w3schools.com/w3css/default.asp" target="_blank" rel="noreferrer">w3.css.</a>   Icons by <a href="https://icons8.com/" target="_blank" rel="noreferrer">Icons8</a></p>
            </footer>
        </div>

    )
}

export default Home;